<template>
    <div class="kt-portlet">
        <div class="kt-portlet__body" style="color: black; background-color: #fff">
            <h6>{{ $t('dashboard.label.open_tickets') }}</h6>
            <div class="text-center">
                <h2 class="fix-margin">
                    {{ ticket.open }}
                </h2>
            </div>
            <div class="line-divider mt-4 mb-3"></div>
            <div class="row">
                <div class="col-md-6 col-lg-6 col-sm-6 border-right">
                    <div class="mb-3" style="font-size: 0.82rem">{{ $t('dashboard.label.replied_tickets') }}</div>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{ ticket.replied }}
                        </h4>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-6">
                    <div class="mb-3" style="font-size: 0.82rem">
                        {{ $t('dashboard.label.total_tickets') }}
                    </div>
                    <div class="text-center">
                        <h4 class="fix-margin">
                            {{ ticket.total }}
                        </h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "tickets",

        props: {
            ticket: {
                default() {
                    return {}
                }
            },
        },
    }
</script>

<style scoped>

</style>